/**
 * JWT Token Config — Bifrost Migration
 * 
 * Previously: Decoded JWT from cookie/localStorage, exported userdata synchronously.
 * Now: Module-level mutable object, populated by BifrostAuthGate BEFORE app renders.
 * 
 * The key insight: populateUserData() is called before any component mounts,
 * so all 27 components that do `import userdata from '../config/jwt_token'`
 * continue to work with ZERO changes. The object reference stays the same —
 * only its properties get populated.
 * 
 * IMPORTANT: Do NOT replace `userdata` reference — use Object.assign to mutate
 * the same object reference that all importers hold.
 */

// Module-level mutable object — holds user profile data
// Populated by BifrostAuthGate after backend /api/v1/user/me resolves
let userdata = {};

/**
 * Populate the userdata object with user profile from backend
 * Called by BifrostAuthGate after successful authentication
 * 
 * @param {Object} data - { id, emp_id, city, role, role_label, email, name }
 */
export const populateUserData = (data) => {
  // MUST use Object.assign to mutate the same reference
  // so all existing importers see the updated data
  Object.assign(userdata, data);
};

/**
 * Clear userdata (on logout)
 */
export const clearUserData = () => {
  Object.keys(userdata).forEach(key => delete userdata[key]);
};

export default userdata;


// WEBPACK FOOTER //
// ./src/config/jwt_token.js